import React from 'react';
import { HorizontalTabBar, OverlaySpinner, colors } from '@insurancemenu/imenu-components-lib';
import { observer } from 'mobx-react-lite';
import {
  ManageConditionModalDelegate,
  NEW_FAMILY_MEMBER_TAB_ID,
} from 'store/modules/subscriber/health-questionnaire/manageConditionModalDelegate';
import { FamilyMemberForm } from '../FamilyMemberForm';
import { getManageConditionFormId } from '../constants';
import { buildMemberSelectOptions } from '../helpers';
import { TabsContentWrapperStyled } from './styles';

interface HorizontalTabsProps {
  manageConditionModalDelegate: ManageConditionModalDelegate;
}

export const HorizontalTabs: React.FC<HorizontalTabsProps> = observer(({ manageConditionModalDelegate }) => {
  const {
    memberTabs,
    activeMemberId,
    setActiveMemberId,
    activeMemberForm,
    isLoading,
    familyCensus,
    activeMemberSelectIds,
    deleteMemberForm,
  } = manageConditionModalDelegate;

  if (!activeMemberForm) {
    return null;
  }

  function onDeleteMemberForm(): void {
    void deleteMemberForm(activeMemberId);
  }

  function getTabColor(tabId: string): string {
    if (tabId !== activeMemberId) return colors.neutral[700];
    if (tabId === NEW_FAMILY_MEMBER_TAB_ID) return colors.green[600];
    return colors.blue[600];
  }
  const tabs = memberTabs.map((tab) => ({
    ...tab,
    customColor: getTabColor(tab.id),
  }));

  const memberSelectOptions = buildMemberSelectOptions(activeMemberSelectIds, familyCensus);

  return (
    <HorizontalTabBar tabs={tabs} activeTabId={activeMemberId} setActiveTab={setActiveMemberId}>
      <TabsContentWrapperStyled>
        <FamilyMemberForm
          key={activeMemberId}
          formController={activeMemberForm}
          id={getManageConditionFormId(activeMemberId)}
          memberSelectOptions={memberSelectOptions}
          isNewMemberForm={activeMemberId === NEW_FAMILY_MEMBER_TAB_ID}
          deleteForm={onDeleteMemberForm}
        />
        {isLoading && <OverlaySpinner display />}
      </TabsContentWrapperStyled>
    </HorizontalTabBar>
  );
});
